// Parser for Warmane/CavernOfTime raid statistics HTML
// Exports parseTable(html) which returns an array of { boss, code, value, rawDesc, rawValue }

function cleanHtml(raw) {
  if (!raw) return '';
  let s = raw.replace(/\\+/g, '');
  s = s.replace(/<\s*\/\s*/g, '</');
  s = s.replace(/<\s+/g, '<');
  s = s.replace(/\s+>/g, '>');
  s = s.replace(/\s+/g, ' ');
  return s;
}

function extractRows(html) {
  const rows = [];
  const trRe = /<tr\b[^>]*>([\s\S]*?)<\/tr>/gi;
  let m;
  while ((m = trRe.exec(html)) !== null) rows.push(m[1]);
  return rows;
}

function extractTds(trInner) {
  const tds = [];
  const tdRe = /<td\b[^>]*>([\s\S]*?)<\/td>/gi;
  let m;
  while ((m = tdRe.exec(trInner)) !== null) {
    const inner = m[1].replace(/<[^>]+>/g, '').trim();
    tds.push(inner);
  }
  return tds;
}

const ICC_RE = /\(\s*(Heroic\s+)?Icecrown\s*(10|25)\s*player\s*\)$/i;

export function parseTable(html) {
  const cleaned = cleanHtml(html || '');
  const tbodyMatch = cleaned.match(/<tbody[^>]*>([\s\S]*?)<\/tbody>/i);
  const body = tbodyMatch ? tbodyMatch[1] : cleaned;
  const rows = extractRows(body);
  const out = [];
  for (const rowInner of rows) {
    const tds = extractTds(rowInner);
    if (tds.length < 2) continue;
    const desc = tds[0];
    const valRaw = tds[1];
    let code = null;
    let boss = desc;
    const iccMatch = desc.match(ICC_RE);
    if (iccMatch) {
      const heroic = !!iccMatch[1];
      const size = iccMatch[2];
      code = `ICC ${size}${heroic ? 'HC' : 'NM'}`;
      boss = desc.replace(ICC_RE, '').trim();
    }
    let value = null;
    const v = valRaw.replace(/,/g, '').trim();
    if (/^-+$/i.test(v) || v === '') value = null;
    else {
      const n = parseInt(v, 10);
      value = Number.isNaN(n) ? null : n;
    }
    out.push({ boss, code, value, rawDesc: desc, rawValue: valRaw });
  }
  return out;
}

const exported = { parseTable };
export default exported;
